export function logLocation(calledIndexModifier = 2) {
    const e = new Error();
    const stack = e.stack?.split("\n")[calledIndexModifier]; // 0 = Error, 1 = this function, 2 = caller

    return extractFileAndLine(stack!);
}

export function extractFileAndLine(stackLine: string): string | null {
    const match = stackLine.match(/\/src\/.*?:\d+/);

    return match ? match[0].replace("/src/", "/") : null;
}
